<template>
    <header class="hero-banner" :class="$mq" :style="{ backgroundImage: `url('${image}')` }">
        <div class="container">
            <div class="hero-content">
                <h1>La solution pour vos pièces mécaniques !</h1>
                <h4>Au coeur de la Normandie</h4>
                <p>
                    Situé à Mortagne-au-Perche en Normandie, <b>Blanchard</b> s'adresse à <b>tous les secteurs d'activité</b> et <b>toutes les entreprises</b>, peu importe votre localisation en France ! Pièces mécaniques unitaires, en petite ou en moyenne série, nous nous tenons <b>prêt à assurer votre commande</b>.
                </p>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    name: "HeroBanner",
    props: {
        image: String
    }
}
</script>

<style lang="scss" scoped>
    .hero-banner {
        background-size: cover;
        background-position: 50%;
        height: 95vh;

        display: flex;
        align-items: center;
        justify-content: left;

        .hero-content {
            max-width: 50%;
            padding: 40px;
            background-color: $primary60;
            color: $white;

            h4 {
                font-style: italic;
            }
        }

        &.tablet {
            .hero-content {
                margin-top: -100px;
                max-width: 100%;
            }
        }

        &.mobile {
            height: 120vh;
            padding-top: 100px;

            h1 {
                font-size: 24pt;
            }

            .hero-content {
                max-width: 100%;
            }
        }
    }
</style>